<template>
  <div class="w-screen flex flex-col gap-12 sm:gap-16 md:gap-24 lg:gap-[120px]">
    <div class="container mx-auto flex flex-col gap-12 sm:gap-16 md:gap-24 lg:gap-[120px]">
      <!-- BANNER -->
      <div>
        <Banner title="PRICING_BANNER_HEADING" description="PRICING_BANNER_DESC" />
      </div>
      <!-- PRICING PACKAGE -->
      <PricingPackage />
      <!-- FAQS -->
      <div
        class="bg-banner bg-cover xl:py-30 lg:py-20 md:py-10 py-5 1.5xl:px-[270px] xl:px-30 lg:px-20 1.5md:px-15 md:px-10 px-5 rounded-19"
      >
        <div class="flex flex-col items-center relative">
          <div class="flex flex-col flex-wrap items-center text-center px-10 1.5xl:px-16 gap-7">
            <h2 v-i18n="landingPage">FAQs</h2>
            <p2 v-i18n="landingPage">FAQ_DESCRIPTION</p2>
          </div>
          <div class="w-full">
            <div v-for="(item, index) in faqs" :key="index" class="rounded-2xl bg-white mt-5">
              <Faqs :options="item" />
            </div>
          </div>
        </div>
      </div>
      <!-- TOUCH WITH US -->
      <TouchWithUs />
    </div>
    <!-- FOOTER -->
    <Footer />
  </div>
</template>

<script>
import Banner from '@/src/components/misc/Banner.vue'
import Footer from '@src/components/misc/Footer.vue'
import Faqs from '@src/components/misc/Faqs.vue'
import { navbarLinks } from '@src/constants/general-constants'
import { useMeta } from 'vue-meta'
import PricingPackage from '@src/views/pricing-page/PricingPackage.vue'
import TouchWithUs from '@src/views/home-page/TouchWithUs.vue'
export default {
  components: {
    Banner,
    PricingPackage,
    Faqs,
    TouchWithUs,
    Footer,
  },
  setup() {
    useMeta({
      title: 'Pricing',
      meta: [{ name: 'description', content: 'Home' }],
    })
  },
  data() {
    return {
      pricingUsers: null,
      currentPackage: null,
      landingPage: 'landingPage',
      navbarLinks,
      faqs: [
        {
          question: 'Q1',
          answer: 'A1',
        },
        {
          question: 'Q2',
          answer: 'A2',
        },
        {
          question: 'Q3',
          answer: 'A3',
        },
        {
          question: 'Q4',
          answer: 'A4',
        },
        {
          question: 'Q5',
          answer: 'A5',
        },
        {
          question: 'Q6',
          answer: 'A6',
        },
        {
          question: 'Q7',
          answer: 'A7',
        },
        {
          question: 'Q8',
          answer: 'A8',
        },
        {
          question: 'Q9',
          answer: 'A9',
        },
        {
          question: 'Q10',
          answer: 'A10',
        },
      ],
      price: 0,
      addOnes: [],
      removedItem: null,
      pricingPage: true,
      plan: null,
    }
  },
  watch: {
    pricingUsers: {
      handler() {
        this.calculatePackage()
      },
      immidiate: true,
    },
  },
  methods: {
    goToPricingDetails() {
      if (this.currency === 'PKR') {
        this.$router.push({ name: 'pricing-details' })
      } else {
        this.$router.push({ name: 'pricing-details' })
      }
    },
    packageChanged(val) {
      this.currentPackage = val
      this.calculatePackage()
    },
    calculateAll() {},
    calculatePackage() {
      if (this.currentPackage.label === 'Basic Package') {
        switch (true) {
          case this.pricingUsers <= 20: {
            this.price = '5.0'
            break
          }
          case this.pricingUsers <= 50: {
            this.price = '4.5'
            break
          }
          case this.pricingUsers <= 100: {
            this.price = '4.0'
            break
          }
          case this.pricingUsers <= 200: {
            this.price = '3.5'
            break
          }
          case this.pricingUsers <= 500: {
            this.price = '3.0'
            break
          }
          case this.pricingUsers <= 1000: {
            this.price = '2.5'
            break
          }
          default: {
            this.price = null
            break
          }
        }
      } else if (this.currentPackage.label === 'Standard Package') {
        switch (true) {
          case this.pricingUsers <= 100: {
            this.price = '0.5'
            break
          }
          case this.pricingUsers <= 300: {
            this.price = '0.45'
            break
          }
          case this.pricingUsers <= 500: {
            this.price = '0.4'
            break
          }
          case this.pricingUsers <= 1000: {
            this.price = '0.35'
            break
          }
          case this.pricingUsers <= 1500: {
            this.price = '0.3'
            break
          }
          case this.pricingUsers <= 2000: {
            this.price = '0.25'
            break
          }
          default: {
            this.price = null
            break
          }
        }
      }
    },
    addOneList(list) {
      this.addOnes = list
    },
    removeAddOne(item) {
      this.removedItem = item
    },
    planSelected(item) {
      this.plan = item.name
    },
  },
}
</script>
